import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './OAuthSuccess.module.css';

const OAuthSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(3);
  
  const status = searchParams.get('status');
  const platform = searchParams.get('platform');
  const message = searchParams.get('message');
  const accountId = searchParams.get('account');

  const isSuccess = status === 'success';
  const platformName = platform ? platform.charAt(0).toUpperCase() + platform.slice(1) : 'Platform';

  useEffect(() => {
    // Send message to parent window (original tab)
    if (window.opener) {
      const messageData = {
        type: isSuccess ? 'OAUTH_SUCCESS' : 'OAUTH_ERROR',
        platform,
        accountId,
        message,
        timestamp: Date.now()
      };
      
      window.opener.postMessage(messageData, window.location.origin);
    }

    // Start countdown and auto-close
    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          // Close the window after countdown
          setTimeout(() => {
            window.close();
          }, 500);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isSuccess, platform, accountId, message]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {isSuccess ? (
          <>
            <div className={styles.successIcon}>✅</div>
            <h1 className={styles.title}>Connection Successful!</h1>
            <p className={styles.description}>
              Your {platformName} account has been connected successfully.
            </p>
            <div className={styles.processingText}>
              <span className={styles.loadingDot}></span>
              <span className={styles.loadingDot}></span>
              <span className={styles.loadingDot}></span>
              Updating your accounts...
            </div>
          </>
        ) : (
          <>
            <div className={styles.errorIcon}>❌</div>
            <h1 className={styles.title}>Connection Failed</h1>
            <p className={styles.description}>
              Failed to connect your {platformName} account.
            </p>
            {message && (
              <p className={styles.errorMessage}>
                {decodeURIComponent(message)}
              </p>
            )}
          </>
        )}
        
        <div className={styles.autoClose}>
          <div className={styles.countdownCircle}>
            <span className={styles.countdownNumber}>{countdown}</span>
          </div>
          <p className={styles.autoCloseText}>
            This window will close automatically in {countdown} second{countdown !== 1 ? 's' : ''}
          </p>
        </div>

        <button 
          className={styles.closeButton}
          onClick={() => window.close()}
        >
          Close Now
        </button>
      </div>

      {/* Futuristic background effect */}
      <div className={styles.backgroundEffect}></div>
    </div>
  );
};

export default OAuthSuccess;
